import { ActionButtonProps, Box, Loader, Spacer, Text } from '@jfs/ui-new'
import { NavigationProp } from '@react-navigation/native'
import { getInitialValues, stateConstForEditLink } from './StateConstant'

export const renderActionButtons = (
  navigation: NavigationProp,
  props: ActionButtonProps,
  reviewPaymentLinkSelected: boolean,
  updateReviewPaymentLink: () => void,
  updateReviewData: (data: Array<any>) => void,
  generatePaymentLink: (data: Array<any>) => void,
  updateInitialVal: (data: any) => void,
  isLoading: boolean,
) => {
  const isValid = props?.isValid

  return (
    <Box alignSelf="flex-end" flexDirection="row" justify="center">
      <Box
        testID="btn-action"
        onPress={() => (reviewPaymentLinkSelected ? updateReviewPaymentLink() : navigation?.goBack())}
        justify="center"
        underlayColor="TRANSPARENT"
        borderWidth={0.5}
        borderRadius={8}
        borderColor="LIGHTEST_GREY"
        pv={5}
        ph={10}>
        <Text fontWeight={'600'} fontSize={12} color="BLUE">
          {reviewPaymentLinkSelected ? 'Edit' : 'Cancel'}
        </Text>
      </Box>
      <Spacer direction="horizontal" size={16} />
      <Box
        testID="genPayLinkBtn"
        onPress={() =>
          reviewPaymentLinkSelected
            ? generatePaymentLink(stateConstForEditLink(props?.values))
            : [
                updateInitialVal(getInitialValues(props?.values)),
                updateReviewPaymentLink(),
                updateReviewData(stateConstForEditLink(props?.values)),
              ]
        }
        disabled={!isValid || isLoading}
        bg="BLUE"
        underlayColor="TRANSPARENT"
        opacity={isValid ? 1 : 0.5}
        pv={5}
        ph={18}
        borderRadius={6}
        justifyContent="center">
        {isLoading ? (
          <Loader color="WHITE" />
        ) : (
          <Text type={'body2'} fontWeight={'600'} fontSize={12} color="WHITE">
            {'Generate Payment Link'}
          </Text>
        )}
      </Box>
    </Box>
  )
}
